import template from './ordenes.html';
import procesarTemplate from '../detalles-list/procesar-comision.html';
import autorizarTemplate from '../detalles-list/cancelar.html';

import { FormActions } from 'core/services/form';
import ordenesI18N from 'i18n/ordenes/es.json';
import { rest } from 'core/api';
import { formatErrorMessage } from 'core/util';


export let OrdenesComponent = {
  templateUrl: template,
  selector: 'ordenes',
  bindings: {
    translations: '='
  },
  controller: OrdenesCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(ordenesI18N).concat(commonsI18N);

OrdenesCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService', 'CustomModal', '$filter'
];

function OrdenesCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService, CustomModal, $filter) {

  var defaultColumnOrder = ['numero', 'cliente.razonSocial', 'cita.numero', 'cita.fecha', 'fecha', 'tipo.value', 'estado.value'];
  var staticFilter = Filter.path('activo').eq(true);
  BasicFactory.setup('ordenes');

  const estadoQuery = Filter.path('tipo.codigo').eq('estado_orden_trabajo');
  const estadoUrl = encodeURI('valores?filter=' + JSON.stringify(estadoQuery));

  const tipoQuery = Filter.path('tipo.codigo').eq('tipo_orden_trabajo');
  const tipoUrl = encodeURI('valores?filter=' + JSON.stringify(tipoQuery));


  this.options = {
    staticFilter,
    resource: 'ordenes-de-trabajo',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de ordenes'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'numero', title: this.translations['Número'] },
      { data: 'cliente.razonSocial', title: this.translations['Cliente'] },
      { 
        data: 'turnoCabecera.numero',
        title: this.translations['Número Turno'],
        render: function(data, type, row) {
          return row.turnoCabecera ? row.turnoCabecera.numero : '<i>No establecido</i>';
        }
      },
      { 
        data: 'cita.numero',
        title: this.translations['Número Cita'],
        render: function(data, type, row) {
          return row.cita ? row.cita.numero : '<i>No establecido</i>';
        }
      },
      { 
        data: 'cita.fecha',
        title: this.translations['Fecha Cita'],
        type: 'date-range',
        render: function(data, type, row) {
          return row.cita ? row.cita.fecha : '<i>No establecido</i>';
        }
      },
      { data: 'fecha', title: this.translations['Fecha Orden'], type: 'date-range' },
      { data: 'fechaFinalizacion', title: this.translations['Fecha Finalizacion'], type: 'date-range' },
      {
        data: 'tipo.value',
        title: this.translations['Tipo'],
        type: 'combo',
        filterUrl: tipoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.tipo ? row.tipo.name : '<i>No establecido</i>';
        }
      },
      {
        data: 'estado.value',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.estado ? row.estado.name : '<i>No establecido</i>';
        }
      }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onRemove: onRemove.bind(this),
    onView: onView.bind(this),
    canEditCondition: canEditCondition.bind(this),
    canRemoveCondition: canRemove.bind(this),
    canCancelar: canCancelar.bind(this),
    canFinalizar: canFinalizar.bind(this),
    canReabrir: canReabrir.bind(this),
    canProcesar: canProcesar.bind(this),
    canAutorizar: canAutorizar.bind(this),
    canGoFactura: canGoFactura.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-warning btn-dt" uib-tooltip="' + this.translations['Finalizar'] + '" ng-show="options.canFinalizar(rowsData[<%= dataId %>])" ng-click="finalizarOrden(<%= dataId %>)"> <span class="glyph-icon icon-check-circle-o" style="top: -8px;"></span></button>',
        functionName: 'finalizarOrden',
        functionDef: (itemId) => {
          let self = this;
          CustomModal.open({
            title: 'Finalizar',
            id: itemId,
            message: '¿Desea finalizar la orden?',
            ok: function() {
              $ngRedux.dispatch(rest.actions.finalizarOrden({ id: itemId }, {
                body: JSON.stringify({})
              }, (err, data) => {
                if (!err && data.estado.value == 'Finalizada') {
                  ngNotify.set(self.translations['Finalizada Correctamente'], 'success');
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-warning btn-dt" uib-tooltip="' + this.translations['Re Abrir'] + '" ng-show="options.canReabrir(rowsData[<%= dataId %>])" ng-click="reabrirOrden(<%= dataId %>)"> <span class="glyph-icon icon-mail-forward" style="top: -8px;"></span></button>',
        functionName: 'reabrirOrden',
        functionDef: (itemId) => {
          let self = this;
          CustomModal.open({
            title: 'Re Abrir',
            id: itemId,
            message: '¿Desea re abrir la orden?',
            ok: function() {
              $ngRedux.dispatch(rest.actions.reabrirOrden({ id: itemId }, {
                body: JSON.stringify({})
              }, (err, data) => {
                if (!err && data.estado.value == 'En proceso') {
                  ngNotify.set(self.translations['Reabierta Correctamente'], 'success');
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-danger btn-dt" uib-tooltip="' + this.translations['Cancelar'] + '" ng-show="options.canCancelar(rowsData[<%= dataId %>])" ng-click="cancelarOrden(<%= dataId %>)"> <span class="glyph-icon icon-close" style="top: -8px;"></span></button>',
        functionName: 'cancelarOrden',
        functionDef: (itemId) => {
          let self = this;
          CustomModal.open({
            title: 'Cancelar',
            id: itemId,
            message: '¿Desea cancelar la orden?',
            ok: function() {
              $ngRedux.dispatch(rest.actions.cancelarOrden({ id: itemId }, {
                body: JSON.stringify({})
              }, (err, data) => {
                if (!err && data.estado.value == 'Cancelada') {
                  ngNotify.set(self.translations['Cancelada Correctamente'], 'success');
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-success btn-dt" uib-tooltip="' + this.translations['Ver Factura'] + '" ng-show="options.canGoFactura(rowsData[<%= dataId %>])" ng-click="verFactura(<%= dataId %>)"> <span class="glyph-icon icon-file-text-o" style="top: -8px;"></span></button>',
        functionName: 'verFactura',
        functionDef: (itemId) => {
          $ngRedux.dispatch(rest.actions.facturaDeOrden({ id: itemId }, {
            body: JSON.stringify({})
          }, (err, data) => {
            if (!err && data.id) {
              $state.go('home.facturas.uid.view', { uid: data.id });
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Autorizar'] + '" ng-show="options.canAutorizar(rowsData[<%= dataId %>])" ng-click="autorizarOrden(<%= dataId %>)"> <span class="glyph-icon icon-check" style="top: -8px;"></span></button>',
        functionName: 'autorizarOrden',
        functionDef: (itemId) => {
          $ngRedux.dispatch(rest.actions.autorizarOrden({ id: itemId }, {
            body: JSON.stringify({})
          }, (err, data) => {
            if (!err && data.codigo) {
              CustomModal.open({
                title: 'Autorización de Orden',
                id: itemId,
                ocultarCancelar: true,
                templateUrl: autorizarTemplate,
                message: 'El código de autorización es:',
                messageStrong: data.codigo,
                ok: function() {}
              });
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-warning btn-dt" uib-tooltip="' + this.translations['Procesar Comisión'] + '" ng-show="options.canProcesar(rowsData[<%= dataId %>])" ng-click="procesarComision(rowsData[<%= dataId %>])"> <span class="glyph-icon icon-gears" style="top: -8px;"></span></button>',
        functionName: 'procesarComision',
        functionDef: (row) => {
          let self = this;
          let payload = { tipo: { value: 'Giftcard' } };
          CustomModal.open({
            title: 'Procesar Comisión',
            item: row,
            vm: self,
            payload,
            hideTipo: true,
            templateUrl: procesarTemplate,
            message: 'Procesar comisión para esta Orden Utilizando Giftcard Gentileza',
            ok: function() {
              let requestPayload = {};

              if (payload.giftcard) {
                requestPayload.giftcardId = payload.giftcard.id;
                requestPayload.codigoAutorizacion = payload.codigoAutorizacion;
              } else {
                return false;
              }

              $ngRedux.dispatch(rest.actions.procesarComisionOrden({ id: row.id }, {
                body: JSON.stringify(requestPayload)
              }, (err, data) => {
                if (!err && (data.tipo.value === 'Giftcard' || data.tipo.value === 'Gentileza')) {
                  ngNotify.set(self.translations['Comision con giftcard procesada'], 'success');
                  if (!data.periodoNomina) {
                    ngNotify.set(self.translations['Comision con giftcard procesada (sin periodo nomina)'], 'warn');
                  }
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          });
        }
      }]
  };

  function canAutorizar(data) {
    return (data.tipo.value === 'Cita' || data.tipo.value === 'Turno') && (data.estado.value === 'En proceso' || data.estado.value === 'Finalizada') && AuthorizationService.hasPermission('auth_orden_trabajo');
  }

  function canRemove(data) {
    return false;
  }

  function canEditCondition(data) {
    return (data.estado.value === 'En proceso' || data.estado.value === 'Finalizada') && AuthorizationService.hasPermission('update_orden_trabajo');
  }

  function canCancelar(data) {
    return (data.estado.value === 'En proceso') && AuthorizationService.hasPermission('update_orden_trabajo');
  }

  function canFinalizar(data) {
    return (data.estado.value === 'En proceso') && AuthorizationService.hasPermission('reabrir_orden_trabajo');
  }

  function canReabrir(data) {
    return (data.estado.value === 'Finalizada') && (data.tipo.value === 'Cita' || data.tipo.value === 'Turno') && AuthorizationService.hasPermission('reabrir_orden_trabajo');
  }

  function canProcesar(data) {
    return (data.estado.value === 'Finalizada' && (data.tipo.value === 'Cita' || data.tipo.value === 'Turno')) && AuthorizationService.hasPermission('update_orden_trabajo');
  }

  function canGoFactura(data) {
    return data.estado.value === 'Facturada';
  }

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.gotoForm = gotoForm.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de ordenes']
    };
    this.form();
  };

  function mapStateToThis(state) {

    this.handleStatus(state);
    return { form: state.form };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

  }

  function gotoForm() {
    $state.go('home.ordenes.new');
  }

  function onEdit(itemId) {
    $state.go('home.ordenes.uid.edit', { uid: itemId });
  }

  function onRemove(itemId) {
    this.remove('ordenes-de-trabajo', itemId);
  }

  function onView(itemId) {
    $state.go('home.ordenes.uid.view', { uid: itemId });
  }

  this.renderGiftcard = renderGiftcard.bind(this);

  function renderGiftcard(giftcard) {
    return `${giftcard.codigo} (${$filter('currency')(giftcard.montoRestante, 'Gs.', 0)})`;
  }

  this.loadGiftcards = loadGiftcards.bind(this);

  function loadGiftcards(query) {
    let today = new Date();
    let filter = Filter.path('vigenciaInicio').lte(today)
      .and(Filter.path('vigenciaFin').gte(today))
      .and(Filter.path('estado.value').eq('Habilitada')
        .and(Filter.path('tipo.value').eq('Gentileza')));

    if (query) {
      filter = filter.and(Filter.path('codigo').like(query));
    }

    BasicFactory.setup('giftcards');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }
}


// WEBPACK FOOTER //
// ./src/components/ordenes/list/ordenes.component.js